"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3549],{

/***/ 41743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ createLoginUrl; }
/* harmony export */ });
function createLoginUrl(redirectTo) {
    if (redirectTo) {
        return "/api/login?returnTo=".concat(encodeURIComponent(redirectTo));
    }
    return "/api/login";
}


/***/ }),

/***/ 76852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_ActionsFooter; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/next/node_modules/styled-jsx/style.js
var style = __webpack_require__(87603);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./src/utils/paths.ts
var paths = __webpack_require__(8319);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/utils/classNames.ts
var classNames = __webpack_require__(25746);
// EXTERNAL MODULE: ./src/client/contexts/chat/index.tsx + 1 modules
var chat = __webpack_require__(96082);
// EXTERNAL MODULE: ./src/client/graphql/client.ts + 2 modules
var client = __webpack_require__(51559);
// EXTERNAL MODULE: ./src/client/generated/index.ts + 3 modules
var generated = __webpack_require__(15229);
;// CONCATENATED MODULE: ./src/client/components/Footer/LoggedInFooter.tsx











/**
 * ログイン状態に表示するフッター
 */ function LoggedInFooter(param) {
    var token = param.token;
    var ref = (0,react.useState)(""), currentPath = ref[0], setCurrentPath = ref[1];
    var ref1 = (0,react.useContext)(chat/* ChatContext */.p), chatClient = ref1.chatClient, unreadCount = ref1.unreadCount, chatDispatch = ref1.chatDispatch;
    (0,react.useEffect)(function() {
        setCurrentPath(location.pathname);
    }, []);
    (0,react.useEffect)(function() {
        if (chatClient != null) {
            return;
        }
        (0,_async_to_generator/* default */.Z)(function() {
            var graphqlClient, ref, currentUser, data, _workerProfile, representativeImage, firstName, lastName, name;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        graphqlClient = (0,client/* initializeGraphqlClient */.U)();
                        return [
                            4,
                            graphqlClient.query({
                                query: generated/* CurrentUserDocument */.T0H,
                                variables: {
                                    token: token
                                }
                            })
                        ];
                    case 1:
                        ref = _state.sent(), currentUser = ref.data.currentUser;
                        return [
                            4,
                            graphqlClient.query({
                                query: generated/* WorkerProfileDocument */.o8I,
                                variables: {
                                    id: currentUser.id,
                                    token: token
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        _workerProfile = data.workerProfile, representativeImage = _workerProfile.representativeImage, firstName = _workerProfile.firstName, lastName = _workerProfile.lastName;
                        name = lastName + " " + firstName;
                        return [
                            4,
                            chatDispatch({
                                type: "initializeChatClient",
                                payload: {
                                    token: token,
                                    user: {
                                        id: currentUser.id,
                                        name: name,
                                        image: representativeImage ? representativeImage : undefined
                                    }
                                }
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        chatClient
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-40bd0cd341be9ad6" + " " + "actions-footer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-40bd0cd341be9ad6" + " " + "w-full flex  box-border border-solid border-t border-gray fixed bottom-0 bg-white justify-around footer-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: paths/* paths.top */.H.top,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            "aria-label": "さがすボタン",
                            className: "jsx-40bd0cd341be9ad6" + " " + "icons-margin",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: currentPath === paths/* paths.top */.H.top ? "/icons/footer-search-green.svg" : "/icons/footer-search-gray.svg",
                                alt: "",
                                className: "jsx-40bd0cd341be9ad6"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: paths/* paths.application.schedule */.H.application.schedule,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: "jsx-40bd0cd341be9ad6" + " " + ((0,classNames/* classNames */.A)("icons-margin flex items-center flex-col text-light-gray4", currentPath === paths/* paths.application.schedule */.H.application.schedule && "pointer-events-none text-[#48AFAA]") || ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: currentPath === paths/* paths.application.schedule */.H.application.schedule ? "/icons/footer-experience-green.svg" : "/icons/footer-experience-gray.svg",
                                    alt: "",
                                    className: "jsx-40bd0cd341be9ad6"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "jsx-40bd0cd341be9ad6" + " " + "text-[8px] leading-3 mt-[2px] ".concat(currentPath === paths/* paths.application.schedule */.H.application.schedule ? "text-green" : ""),
                                    children: "応募"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: paths/* paths.chat */.H.chat,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: "jsx-40bd0cd341be9ad6" + " " + ((0,classNames/* classNames */.A)("icons-margin", "relative", currentPath === paths/* paths.chat */.H.chat && "pointer-events-none") || ""),
                            children: [
                                unreadCount > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "jsx-40bd0cd341be9ad6" + " " + "right-[-3px] w-[17px] h-[17px] top-[-3px] text-[11px] rounded-[50%] text-white justify-center flex absolute items-center bg-[#eb4e3d]",
                                    children: unreadCount
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: currentPath === paths/* paths.chat */.H.chat ? "/icons/footer-message-green.svg" : "/icons/footer-message-gray.svg",
                                    alt: "",
                                    className: "jsx-40bd0cd341be9ad6"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: paths/* paths.accounts.favoriteRecruitments */.H.accounts.favoriteRecruitments,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "jsx-40bd0cd341be9ad6" + " " + ((0,classNames/* classNames */.A)("icons-margin", currentPath === paths/* paths.accounts.favoriteRecruitments */.H.accounts.favoriteRecruitments && "pointer-events-none") || ""),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: currentPath == paths/* paths.accounts.favoriteRecruitments */.H.accounts.favoriteRecruitments ? "/icons/footer-favorite-green.svg" : "/icons/footer-favorite-gray.svg",
                                alt: "",
                                className: "jsx-40bd0cd341be9ad6"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: paths/* paths.accounts.mypage */.H.accounts.mypage,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "jsx-40bd0cd341be9ad6" + " " + ((0,classNames/* classNames */.A)("icons-margin", currentPath === paths/* paths.accounts.mypage */.H.accounts.mypage && "pointer-events-none") || ""),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: currentPath === paths/* paths.accounts.mypage */.H.accounts.mypage ? "/icons/footer-mypage-green.svg" : "/icons/footer-mypage-gray.svg",
                                alt: "",
                                className: "jsx-40bd0cd341be9ad6"
                            })
                        })
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "40bd0cd341be9ad6",
                children: ".actions-footer.jsx-40bd0cd341be9ad6{height:var(--global-footer-height)}.icons-margin.jsx-40bd0cd341be9ad6{margin:10px 0 3px}.footer-wrapper.jsx-40bd0cd341be9ad6{padding-bottom:constant(safe-area-inset-bottom);padding-bottom:env(safe-area-inset-bottom)}"
            })
        ]
    });
}
/* harmony default export */ var Footer_LoggedInFooter = (LoggedInFooter);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/auth0/createLoginUrl.ts
var createLoginUrl = __webpack_require__(41743);
;// CONCATENATED MODULE: ./src/client/components/Footer/LoggedOutFooter.tsx






/**
 * 未ログイン状態に表示するフッター
 */ function LoggedOutFooter() {
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-40bd0cd341be9ad6" + " " + "actions-footer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-40bd0cd341be9ad6" + " " + "w-full flex box-border border-solid border-t border-gray fixed bottom-0 bg-white justify-evenly footer-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "jsx-40bd0cd341be9ad6" + " " + "icons-margin",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            "aria-label": "さがすボタン",
                            className: "jsx-40bd0cd341be9ad6" + " " + "cursor-pointer",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/icons/footer-search-gray.svg",
                                    alt: "",
                                    className: "jsx-40bd0cd341be9ad6"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "button",
                                    onClick: function() {
                                        router.push("".concat(paths/* paths.top */.H.top));
                                    },
                                    className: "jsx-40bd0cd341be9ad6" + " " + "hidden"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "jsx-40bd0cd341be9ad6" + " " + "icons-margin",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            className: "jsx-40bd0cd341be9ad6" + " " + "cursor-pointer",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/icons/footer-login-gray.svg",
                                    alt: "",
                                    className: "jsx-40bd0cd341be9ad6"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "button",
                                    onClick: function() {
                                        router.push((0,createLoginUrl/* default */.Z)(window.location.pathname));
                                    },
                                    className: "jsx-40bd0cd341be9ad6" + " " + "hidden"
                                })
                            ]
                        })
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "40bd0cd341be9ad6",
                children: ".actions-footer.jsx-40bd0cd341be9ad6{height:var(--global-footer-height)}.icons-margin.jsx-40bd0cd341be9ad6{margin:10px 0 3px}.footer-wrapper.jsx-40bd0cd341be9ad6{padding-bottom:constant(safe-area-inset-bottom);padding-bottom:env(safe-area-inset-bottom)}"
            })
        ]
    });
}
/* harmony default export */ var Footer_LoggedOutFooter = (LoggedOutFooter);

;// CONCATENATED MODULE: ./src/client/components/Footer/ActionsFooter.tsx




function ActionsFooter(param) {
    var token = param.token;
    return token ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_LoggedInFooter, {
        token: token
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_LoggedOutFooter, {});
}
/* harmony default export */ var Footer_ActionsFooter = (ActionsFooter);


/***/ }),

/***/ 41322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$$": function() { return /* binding */ AppAppealTwo; },
/* harmony export */   "$l": function() { return /* binding */ DocumentIcon; },
/* harmony export */   "A5": function() { return /* binding */ NoScheduleIcon; },
/* harmony export */   "Ab": function() { return /* binding */ MarupochiIcon; },
/* harmony export */   "DJ": function() { return /* binding */ NotificationOnIcon; },
/* harmony export */   "EX": function() { return /* binding */ WorkAddressIcon; },
/* harmony export */   "F9": function() { return /* binding */ TalkOrWatchingIcon; },
/* harmony export */   "H9": function() { return /* binding */ UserProfileIcon; },
/* harmony export */   "HL": function() { return /* binding */ RecreationIcon; },
/* harmony export */   "Hf": function() { return /* binding */ ArrowUpIcon; },
/* harmony export */   "Ip": function() { return /* binding */ InspectionAssistanceIcon; },
/* harmony export */   "JV": function() { return /* binding */ RegisterLicense; },
/* harmony export */   "Jy": function() { return /* binding */ CheckSmallIcon; },
/* harmony export */   "L4": function() { return /* binding */ SpinnerIcon; },
/* harmony export */   "Lp": function() { return /* binding */ HeaderScheduleIcon; },
/* harmony export */   "Nw": function() { return /* binding */ MedicationManagementIcon; },
/* harmony export */   "Oy": function() { return /* binding */ HeaderMessageIcon; },
/* harmony export */   "Qu": function() { return /* binding */ CalendarIcon; },
/* harmony export */   "R0": function() { return /* binding */ LogoutIcon; },
/* harmony export */   "R3": function() { return /* binding */ AppAppealFour; },
/* harmony export */   "RJ": function() { return /* binding */ TrainIcon; },
/* harmony export */   "Rp": function() { return /* binding */ ArrowBackIcon; },
/* harmony export */   "SP": function() { return /* binding */ DriverIcon; },
/* harmony export */   "T0": function() { return /* binding */ CheckboxCheckIcon; },
/* harmony export */   "T3": function() { return /* binding */ ClockIcon; },
/* harmony export */   "Tw": function() { return /* binding */ CloseIcon; },
/* harmony export */   "UO": function() { return /* binding */ QuestionIcon; },
/* harmony export */   "WS": function() { return /* binding */ ReviewHintsIcon; },
/* harmony export */   "YB": function() { return /* binding */ HeaderMenuIcon; },
/* harmony export */   "YU": function() { return /* binding */ DayPickerForwardIcon; },
/* harmony export */   "Z_": function() { return /* binding */ LicenseEmpty; },
/* harmony export */   "av": function() { return /* binding */ MedicalCheckupIcon; },
/* harmony export */   "b2": function() { return /* binding */ NursingWorkIcon; },
/* harmony export */   "di": function() { return /* binding */ VitalCheckIcon; },
/* harmony export */   "eH": function() { return /* binding */ WorkTimeIcon; },
/* harmony export */   "fI": function() { return /* binding */ FavoriteIcon; },
/* harmony export */   "fO": function() { return /* binding */ UnIdentityVerifiedIcon; },
/* harmony export */   "fU": function() { return /* binding */ CheckCircle; },
/* harmony export */   "fz": function() { return /* binding */ SortIcon; },
/* harmony export */   "i$": function() { return /* binding */ IdentityVerifiedIcon; },
/* harmony export */   "j2": function() { return /* binding */ CheckLightGreenIcon; },
/* harmony export */   "k1": function() { return /* binding */ FilterIcon; },
/* harmony export */   "lC": function() { return /* binding */ DayPickerBackIcon; },
/* harmony export */   "lJ": function() { return /* binding */ AppAppealFive; },
/* harmony export */   "m5": function() { return /* binding */ RecruitmentClosedLabel; },
/* harmony export */   "mh": function() { return /* binding */ AppAppealOne; },
/* harmony export */   "mr": function() { return /* binding */ ArrowForwardIcon; },
/* harmony export */   "n_": function() { return /* binding */ FavoriteWhiteIcon; },
/* harmony export */   "nm": function() { return /* binding */ LongTermAssistIcon; },
/* harmony export */   "oI": function() { return /* binding */ PolygonBottomIcon; },
/* harmony export */   "oU": function() { return /* binding */ AppAppealThree; },
/* harmony export */   "oy": function() { return /* binding */ HeaderMypageIcon; },
/* harmony export */   "pj": function() { return /* binding */ FavoritedIcon; },
/* harmony export */   "qC": function() { return /* binding */ SearchGrassIcon; },
/* harmony export */   "rR": function() { return /* binding */ BathAssistIcon; },
/* harmony export */   "tA": function() { return /* binding */ NotificationOffIcon; },
/* harmony export */   "tT": function() { return /* binding */ HeaderFavoriteIcon; },
/* harmony export */   "ve": function() { return /* binding */ ArrowDownIcon; },
/* harmony export */   "xT": function() { return /* binding */ WorkTaskIcon; }
/* harmony export */ });
/* unused harmony exports BreadCrumbArrowIcon, CategoryIcon, MapPointerIcon, MapPointerWhiteIcon, OccupationPaintIcon, RatingStarUnchecked, RatingStarChecked, MapIcon */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87603);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var createIcon = function(src) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 24;
    var ref = typeof opts === "number" ? {
        width: opts
    } : opts, _width = ref.width, width = _width === void 0 ? 24 : _width, _height = ref.height, height = _height === void 0 ? width : _height, margin = ref.margin, dataTestId = ref.dataTestId;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                "data-testid": dataTestId,
                src: src,
                alt: "",
                className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                    [
                        "6ec1a4ad46b4a0c5",
                        [
                            width,
                            height,
                            margin ? "margin: ".concat(margin, " ;") : null
                        ]
                    ]
                ])
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "6ec1a4ad46b4a0c5",
                dynamic: [
                    width,
                    height,
                    margin ? "margin: ".concat(margin, " ;") : null
                ],
                children: "img.__jsx-style-dynamic-selector{width:".concat(width, "px;height:").concat(height, "px;").concat(margin ? "margin: ".concat(margin, " ;") : null, "\n        }")
            })
        ]
    });
};
var CloseIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/close.svg", opts);
});
var BreadCrumbArrowIcon = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function(opts) {
    return createIcon("/icons/breadcrumb-arrow.svg", opts);
})));
var CategoryIcon = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function(opts) {
    return createIcon("/icons/category.svg", opts);
})));
var MapPointerIcon = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function(opts) {
    return createIcon("/icons/map-pointer.svg", opts);
})));
var MapPointerWhiteIcon = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function(opts) {
    return createIcon("/icons/map-pointer-white.svg", opts);
})));
var OccupationPaintIcon = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function(opts) {
    return createIcon("/icons/occupation-paint.svg", opts);
})));
var ArrowForwardIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/arrow-forward.svg", opts);
});
var ArrowDownIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/arrow-down.svg", opts);
});
var ArrowUpIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/arrow-up.svg", opts);
});
var ArrowBackIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/arrow-back.svg", opts);
});
var FilterIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/filter.svg", opts);
});
var CheckboxCheckIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/checkbox-check.svg", opts);
});
var MarupochiIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/marupochi.svg", opts);
});
var RatingStarUnchecked = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function(opts) {
    return createIcon("/icons/rating-star-unchecked.svg", opts);
})));
var RatingStarChecked = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function(opts) {
    return createIcon("/icons/rating-star-checked.svg", opts);
})));
var UserProfileIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/user-profile.svg", opts);
});
var LogoutIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/logout.svg", opts);
});
var TrainIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/train.svg", opts);
});
var CheckSmallIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/check-small.svg", opts);
});
var SearchGrassIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/top-search.svg", opts);
});
var SpinnerIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/spinner.svg", opts);
});
// 介護向け
var WorkTimeIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/care-clock.svg", opts);
});
var WorkAddressIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/care-address.svg", opts);
});
var WorkTaskIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/care-task.svg", opts);
});
var FavoriteIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/favorite.svg", opts);
});
var FavoriteWhiteIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/favorite-white.svg", opts);
});
var FavoritedIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/favorited.svg", opts);
});
var ClockIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/clock.svg", opts);
});
var MapIcon = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function(opts) {
    return createIcon("/icons/map.svg", opts);
})));
var IdentityVerifiedIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/identity-verified.svg", opts);
});
var UnIdentityVerifiedIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/unidentity-verified.svg", opts);
});
var NotificationOffIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/notification-off.svg", opts);
});
var NotificationOnIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/notification-on.svg", opts);
});
var LicenseEmpty = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/license-empty.svg", opts);
});
var RegisterLicense = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/register-license.svg", opts);
});
var RecruitmentClosedLabel = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/recruitment-closed-label.svg", opts);
});
var AppAppealOne = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/lp-app-appeal-number-one.svg", opts);
});
var AppAppealTwo = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/lp-app-appeal-number-two.svg", opts);
});
var AppAppealThree = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/lp-app-appeal-number-three.svg", opts);
});
var AppAppealFour = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/lp-app-appeal-number-four.svg", opts);
});
var AppAppealFive = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/lp-app-appeal-number-five.svg", opts);
});
var CheckCircle = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/lp-check-circle.svg", opts);
});
var TalkOrWatchingIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/talk-or-watching.svg", opts);
});
var DriverIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/driver.svg", opts);
});
var BathAssistIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/bath-assist.svg", opts);
});
var LongTermAssistIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/long-term-assist.svg", opts);
});
var MedicationManagementIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/medication-management.svg", opts);
});
var MedicalCheckupIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/medical-checkup.svg", opts);
});
var NursingWorkIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/nursing-work.svg", opts);
});
var RecreationIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/recreation.svg", opts);
});
var VitalCheckIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/vital-check.svg", opts);
});
var InspectionAssistanceIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/inspection-assistance.svg", opts);
});
var QuestionIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/question.svg", opts);
});
var HeaderMenuIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/header-menu.svg", opts);
});
var HeaderMypageIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/header-mypage.svg", opts);
});
var HeaderFavoriteIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/header-favorite.svg", opts);
});
var HeaderMessageIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/header-message.svg", opts);
});
var HeaderScheduleIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/header-schedule.svg", opts);
});
var PolygonBottomIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/polygon-bottom.svg", opts);
});
var NoScheduleIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/no-schedule.svg", opts);
});
var CheckLightGreenIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/check-light-green.svg", opts);
});
var CalendarIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/calendar.svg", opts);
});
var DocumentIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/document.svg", opts);
});
var SortIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/sort-icon.svg", opts);
});
var ReviewHintsIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/review-hints.svg", opts);
});
//react-day-picker
var DayPickerBackIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/day-picker-back.svg", opts);
});
var DayPickerForwardIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(opts) {
    return createIcon("/icons/day-picker-forward.svg", opts);
});


/***/ }),

/***/ 86868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ FrequentUsedOptions; },
/* harmony export */   "F": function() { return /* binding */ useCustomSnackBar; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42877);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30990);




var FrequentUsedOptions = {
    Bottom: {
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "center"
        },
        style: {
            top: 0
        }
    }
};
var useCustomSnackBar = function() {
    var ref = (0,notistack__WEBPACK_IMPORTED_MODULE_0__/* .useSnackbar */ .Ds)(), enqueueSnackbar = ref.enqueueSnackbar, closeSnackbar = ref.closeSnackbar;
    return {
        enqueueSuccessSnackbar: function(message, overwriteOptions) {
            return enqueueSnackbar(message, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                variant: "success",
                autoHideDuration: 3000,
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, overwriteOptions));
        },
        enqueueErrorSnackbar: function(messageOrError, overwriteOptions) {
            return enqueueSnackbar(getErrorMessage(messageOrError), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                variant: "error",
                persist: true,
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, overwriteOptions));
        },
        enqueueInfoSnackbar: function(message, overwriteOptions) {
            return enqueueSnackbar(message, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                variant: "info",
                autoHideDuration: 3000,
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, overwriteOptions));
        },
        closeSnackbar: function(key) {
            return closeSnackbar(key);
        }
    };
};
var getErrorMessage = function(messageOrError) {
    if (typeof messageOrError == "string") {
        return messageOrError;
    }
    var error = messageOrError;
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(error, _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .ApolloError */ .c)) {
        if (error.graphQLErrors.length > 0) {
            return error.graphQLErrors[0].message;
        }
        if (error.clientErrors.length > 0) {
            return error.clientErrors[0].message;
        }
        if (error.networkError != null) {
            return error.networkError.message;
        }
        return error.message;
    }
    return error.message;
};


/***/ }),

/***/ 25746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ classNames; }
/* harmony export */ });
var classNames = function() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
};


/***/ }),

/***/ 8319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ paths; }
/* harmony export */ });
var paths = {
    index: "/",
    top: "/top",
    accounts: {
        mypage: "/accounts/mypage",
        availableDates: "/accounts/available_dates",
        delete: "/accounts/delete",
        identity: {
            index: "/accounts/identity",
            precaution: {
                japaneseNationality: "/accounts/identity/precaution/japanese-nationality",
                foreignNationality: "/accounts/identity/precaution/foreign-nationality"
            },
            form: {
                index: "/accounts/identity/form",
                japaneseNationality: "/accounts/identity/form/japanese-nationality",
                foreignNationality: "/accounts/identity/form/foreign-nationality"
            }
        },
        applications: {
            history: "/accounts/applications/history"
        },
        bank: {
            form: "/accounts/bank/form",
            summary: "/accounts/bank/summary",
            transfers: "/accounts/bank/transfers"
        },
        profile: "/accounts/profile",
        license_certificates: {
            index: "/accounts/license_certificates",
            form: {
                upload_image: "/accounts/license_certificates/form/upload_image",
                request_verification: "/accounts/license_certificates/form/request_verification"
            }
        },
        preparations_to_apply: "/accounts/preparations_to_apply",
        penalties: {
            index: "/accounts/penalties",
            histories: "/accounts/penalties/histories",
            remit: "/accounts/penalties/remit"
        },
        registration: {
            start: "/accounts/registration/start",
            done: "/accounts/registration/done",
            licenses: {
                index: "/accounts/registration/licenses",
                form: "/accounts/registration/licenses/form"
            },
            license_certificates: {
                index: "/accounts/registration/license_certificates",
                form: {
                    upload_image: "/accounts/registration/license_certificates/form/upload_image",
                    request_verification: "/accounts/registration/license_certificates/form/request_verification"
                }
            },
            identity: {
                index: "/accounts/registration/identity",
                precaution: {
                    japaneseNationality: "/accounts/registration/identity/precaution/japanese-nationality",
                    foreignNationality: "/accounts/registration/identity/precaution/foreign-nationality"
                },
                form: {
                    index: "/accounts/registration/identity/form",
                    japaneseNationality: "/accounts/registration/identity/form/japanese-nationality",
                    foreignNationality: "/accounts/registration/identity/form/foreign-nationality"
                }
            },
            identityAndContact: {
                index: "/accounts/registration/identity_and_contact"
            },
            bank: {
                form: "/accounts/registration/bank/form",
                summary: "/accounts/registration/bank/summary",
                transfers: "/accounts/registration/bank/transfers"
            },
            incentives: {
                index: "/accounts/registration/incentives",
                histories: "/accounts/registration/incentives/histories",
                exchange: {
                    amazonGiftCard: "/accounts/registration/incentives/exchange/amazon-gift-card"
                }
            },
            profile: "/accounts/registration/profile",
            emergencyContact: "/accounts/registration/emergency_contact",
            preparations_to_apply: "/accounts/registration/preparations_to_apply",
            penalties: {
                index: "/accounts/registration/penalties",
                histories: "/accounts/registration/penalties/histories"
            }
        },
        incentives: {
            index: "/accounts/incentives",
            histories: "/accounts/incentives/histories",
            exchange: {
                amazonGiftCard: "/accounts/incentives/exchange/amazon-gift-card"
            }
        },
        emergencyContact: "/accounts/emergency_contact",
        favoriteRecruitments: "/accounts/favorite_recruitments",
        reviewsFromFacilities: "/accounts/reviews_from_facilities",
        statementOfEarning: "/accounts/statement_of_earnings"
    },
    application: {
        done: "/application/done",
        form: "/application/form",
        schedule: "/application/schedule"
    },
    api: {
        login: "/api/login",
        logout: "/api/logout"
    },
    applications: "/applications",
    attendances: {
        index: "/attendances",
        wageWithoutAdjustment: function(applicationId) {
            return "/attendances/".concat(applicationId, "/wage_without_adjustment");
        },
        wageWithAdjustment: function(applicationId) {
            return "/attendances/".concat(applicationId, "/wage_with_adjustment");
        },
        review: function(applicationId) {
            return "/attendances/".concat(applicationId, "/review");
        },
        longTermLaborSurvey: function(applicationId) {
            return "/attendances/".concat(applicationId, "/long_term_labor_survey");
        },
        favorite: function(applicationId) {
            return "/attendances/".concat(applicationId, "/favorite");
        },
        cancellation: {
            policy: function(applicationId) {
                return "/attendances/".concat(applicationId, "/cancellation/policy");
            },
            form: function(applicationId) {
                return "/attendances/".concat(applicationId, "/cancellation/form");
            }
        }
    },
    chat: "/chat",
    recruitments: {
        index: "/recruitments",
        id: function(recruitmentId) {
            return "/recruitments/".concat(recruitmentId);
        },
        check: {
            application: function(recruitmentId) {
                return "/recruitments/".concat(recruitmentId, "/check/application");
            },
            belonging: function(recruitmentId) {
                return "/recruitments/".concat(recruitmentId, "/check/belonging");
            },
            tasks: function(recruitmentId) {
                return "/recruitments/".concat(recruitmentId, "/check/tasks");
            },
            cancellationPolicy: function(recruitmentId) {
                return "/recruitments/".concat(recruitmentId, "/check/cancel_policy");
            },
            rulesAndManners: function(recruitmentId) {
                return "/recruitments/".concat(recruitmentId, "/check/rules_and_manners");
            },
            licenses: function(recruitmentId) {
                return "/recruitments/".concat(recruitmentId, "/check/licenses");
            },
            documents: function(recruitmentId) {
                return "/recruitments/".concat(recruitmentId, "/check/documents");
            }
        }
    },
    reviews: {
        requests: {
            form: "/reviews/requests/form"
        }
    },
    privacy: "/privacy",
    terms: "/terms",
    cancellationPolicy: "/cancellation_policy"
};


/***/ })

}]);